import React, { useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "./components/page_components/dashboard_layout_components/Sidebar";
import { Outlet } from "react-router-dom";

const DashboardLayout = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState(false); // Sidebar open state

  return (
    <Box display="flex" minHeight="100vh">
      <Sidebar open={openSidebar} onClose={() => setOpenSidebar(false)} />

      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#fafafa",
        }}
      >
        {/* 🔥 Here's where your Dashboard content should render */}
        <Box>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
